import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { SuccessCheckIcon } from "../../assets/img/icons";
import { Link } from "react-router-dom";
// Helper
import { getCookie, setCookie } from "../../lib/helper";
import { COOKIE_SHOW_REFFERRAL_CLOSED_NOTIFICATION_POPUP } from "../../lib/cookie";
import Terminology from "../../lib/Terminology";
import SystemName from "../../Constants/SystemName";

class ClosedReferralsPopup extends React.Component {
  constructor(props) {
    super(props);
    // Set the initial input values
    this.state = {
      isOpen: false,
      closeReferralCount: 0,
      newReferralCount: 0
    };
  }
  componentDidUpdate(prevProps) {
    const pop_status = getCookie(
      COOKIE_SHOW_REFFERRAL_CLOSED_NOTIFICATION_POPUP
    );
    const popup_show = pop_status === "hide" ? false : true;
    if (
      this.state.closeReferralCount !== this.props.closeReferralCount &&
      this.props.closeReferralCount > 0 &&
      popup_show
    ) {
      this.setState({
        isOpen: true,
        closeReferralCount: this.props.closeReferralCount
      });
    }
  }
  _toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
    setCookie(COOKIE_SHOW_REFFERRAL_CLOSED_NOTIFICATION_POPUP, "hide");
  };
  render() {
    return (
      <div>
        <Modal
          isOpen={this.state.isOpen}
          className="referral-modal-popup w-100 text-center mx-auto"
        >
          <ModalHeader
            toggle={this._toggle}
            cssModule={{ "modal-title": "w-100 text-center mt-3" }}
            style={{ backgroundColor: "#DCDCDC" }}
          >
            <div className="d-flex justify-content-center">
              <SuccessCheckIcon />
            </div>
            <div className="font-weight-bold mt-2">
              <span>Congratulations!</span>
              <br />
              <span>
                A {Terminology.get(SystemName.REFERRAL)} has been closed.
              </span>
            </div>
          </ModalHeader>
          <ModalBody className="ml-3 mr-3 mt-2 mb-3">
            <div>
              <span>
                You're ready to review the{" "}
                {Terminology.get(SystemName.REFERRAL)} and
              </span>
              <br />
              <span>
                make a payment for the partner's{" "}
                {Terminology.get(SystemName.REFERRAL)}.
              </span>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="col-md-12 mb-4">
              <Link
                className="text-decoration-none"
                onClick={this._toggle}
                to="/referrals/converted"
              >
                <button id="viewReferralButton" className="btn btn-primary">
                  View the {Terminology.get(SystemName.REFERRAL)}
                </button>
              </Link>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ClosedReferralsPopup;
